'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { TraceLine } from '../../trace';
import type { StreamingContentProps } from '../../tool-config-types';
import {
  ToolCallActivityRows,
  toCodeAnalyzerActivityRow,
} from '../ToolCallActivityRows';

function CodeAnalyzerActivity({
  progressEvents,
  isRunning,
}: StreamingContentProps): ReactNode {
  const t = useTranslations('designSystem.chat.codeAnalyzer');
  const events = (progressEvents ?? []).filter(
    (event) => event.stage !== 'Thinking' && event.stage !== 'Summarizing',
  );

  if (events.length === 0) {
    return isRunning ? (
      <TraceLine title={t('waitingForUpdates')} status="running" />
    ) : null;
  }

  return (
    <ToolCallActivityRows
      rows={events.map(toCodeAnalyzerActivityRow)}
      shimmerLastRow={isRunning}
    />
  );
}

export const renderCodeAnalyzerStreamingContent = (
  props: StreamingContentProps,
): ReactNode => <CodeAnalyzerActivity {...props} />;
